export enum HttpStatusCode {
  NotModified = 304,
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  TooManyRequests = 429,
}
